<div class="d-flex flex-wrap gap-2 align-items-center mb-1">
  <div>Columns:</div>
  <mat-chip-listbox multiple>
    @for (c of table.configToggle(); track c.columnDef) {
      <mat-chip-option [selected]="c.show !== false" (click)="table.toggleColVisibility(c.columnDef)">
        {{ c.header }}
      </mat-chip-option>
    }
  </mat-chip-listbox>
</div>
<div class="table-responsive shadow">
  <table mat-table [dataSource]="table.dataSource()" matSort (matSortChange)="table.sortState.set($event)">
    @for (c of table.config(); track c.columnDef) {
      <ng-container [matColumnDef]="c.columnDef">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ c.header }}</th>
        <td mat-cell *matCellDef="let business">
          @if (c.type === "boolean") {
            <mat-checkbox [checked]="business[c.property]" disabled="true"></mat-checkbox>
          } @else {
            @if (c.onClick) {
              <div (click)="c.onClick(business)" class="pointer">{{ table.formatValue(business, c) }}</div>
            } @else {
              {{ table.formatValue(business, c) }}
            }
          }
        </td>
      </ng-container>
    }
    @if (sharedService.isBossAccount()) {
      <ng-container matColumnDef="Actions" [stickyEnd]="true">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let business">
          <button class="btn" (click)="businessToUpdate(business)" title="Edit"><i class="fas fa-pencil-alt text-secondary"></i></button>
          <button class="btn" (click)="branchToAdd(business.Id)" title="Add Branch"><i class="fas fa-plus text-secondary"></i></button>
        </td>
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns()" [class.inactive]="!row.Active"></tr>
  </table>
</div>
